<template>
    <div class="select-elements" v-if="showSize">
        <span><slot>Nombre d'élements par page&nbsp;:&nbsp;</slot></span>
        <select v-model.number="props.pageSize" @change="changePageSizeHandler">
            <option v-for="size in pageSizes" :key="size" :value="size">{{ size }}</option>
        </select>
    </div>
    <div class="pagination">
        <button v-if="totalPages !== 1" :class="class" @click="prevPage" :disabled="safePage === 1">Précédent</button>

        <span>
            Page&nbsp;:&nbsp;
            <select :value="safePage" @change="event => safePage = Number(event.target.value)">
                <option v-for="page in totalPages" :key="page" :value="page">{{ page }}</option>
            </select>
            /&nbsp;{{ totalPages }}
        </span>

        <button v-if="totalPages !== 1" :class="class" @click="nextPage" :disabled="safePage === totalPages">Suivant</button>
    </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    pageSizes:  { type: Array, default: () => [5, 10, 20, 50] },
    showSize:   { type: Boolean, default: () => true },
    class:      { type: String, default: () => 'primary-button'},
    pageSize:   { type: Number, default: 10 },
    page:       { type: Number, default: 1 },
    totalCount: { type: Number, required: true },
})

const emit       = defineEmits(['update:page', 'update:pageSize'])
const totalPages = computed(() => Math.max(1, Math.ceil(props.totalCount / props.pageSize)))

const safePage = computed({
    get: () => Math.min(props.page, totalPages.value),
    set: val => emit('update:page', val)
})

const nextPage              = () => { if (safePage.value < totalPages.value) safePage.value ++}
const prevPage              = () => { if (safePage.value > 1) safePage.value -- }
const changePageSizeHandler = ( event ) => { 
    emit('update:pageSize', Number(event.target.value))
    emit('update:page', 1) // reset page when pageSize changes
}

const goToPage = ( event ) => {
    emit('update:page', Number(event.target.value))
}
</script>

<style lang="scss" scoped>
.select-elements,
.pagination {
    align-items: center;
    display: flex;
    margin-top: 1rem;
    justify-content: center;
}

.pagination {
    gap: 1rem;

    button:disabled {
        cursor: no-drop;
        opacity: .5;
    }
}
</style>